'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grayPercentage = require('gray-percentage');

var _grayPercentage2 = _interopRequireDefault(_grayPercentage);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodePlugin = function CodePlugin() {
  return function (_ref, options) {
    var rhythm = _ref.rhythm;

    var blockMarginBottom = void 0;
    if ((0, _isNumber2.default)(options.blockMarginBottom)) {
      blockMarginBottom = rhythm(options.blockMarginBottom);
    } else if ((0, _isString2.default)(options.blockMarginBottom)) {
      blockMarginBottom = options.blockMarginBottom;
    } else {
      blockMarginBottom = rhythm(1);
    }
    return {
      'tt,code': {
        backgroundColor: (0, _grayPercentage2.default)(96),
        borderRadius: '3px',
        fontFamily: '"SFMono-Regular", Consolas,"Roboto Mono","Droid Sans Mono","Liberation Mono",Menlo,Courier,monospace',
        padding: 0,
        paddingTop: '0.2em',
        paddingBottom: '0.2em'
      },
      pre: {
        background: (0, _grayPercentage2.default)(96),
        borderRadius: '3px',
        lineHeight: 1.42,
        overflow: 'auto',
        wordWrap: 'normal', // So code will scroll on Safari.
        padding: blockMarginBottom
      },
      'pre code': {
        background: 'none',
        lineHeight: 1.42
      },
      // Add space before and after code/tt elements.
      'code:before,code:after,tt:before,tt:after': {
        letterSpacing: '-0.2em',
        content: '"\xA0"'
      },
      // But don't add spaces if the code is inside a pre.
      'pre code:before,pre code:after,pre tt:before,pre tt:after': {
        content: '""'
      }
    };
  };
};

exports.default = CodePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/typography-plugin-code/dist/index.js
// module id = ./node_modules/typography-plugin-code/dist/index.js
// module chunks = 17241999800008180000